import { getFormattedEncounterType, getFormattedRole } from "lib/wowHelpers";
import React from "react";
import { ReactComponent as IVLogo } from "svg/icy_veins_logo.svg";
import { ReactComponent as ExternalLinkIcon } from "svg/external-link-line.svg";

const TierListCrossLink = ({ encounterType, role }) => {
  const ivLinksAndText = {
    mythic: {
      dps: {
        url: "https://www.icy-veins.com/wow/mythic-dps-tier-list",
        title: "10.2.6 (Season 4) Mythic+ DPS Tier List",
        description: "The current 10.2.6 rankings curated by the pros at Icy Veins!",
      },
      tank: {
        url: "https://www.icy-veins.com/wow/mythic-tank-tier-list",
        title: "10.2.6 (Season 4) Mythic+ Tank Tier List",
        description: "The current 10.2.6 rankings curated by the pros at Icy Veins!",
      },
      heal: {
        url: "https://www.icy-veins.com/wow/mythic-healer-tier-list",
        title: "10.2.6 (Season 4) Mythic+ Healer Tier List",
        description: "The current 10.2.6 rankings curated by the pros at Icy Veins!",
      },
    },
    raid: {
      dps: {
        url: "https://www.icy-veins.com/wow/dps-rankings-tier-list",
        title: "10.2.6 (Season 4) Raid DPS Tier List",
        description: "Weekly rankings curated by the pros at Icy Veins!",
      },
      tank: {
        url: "https://www.icy-veins.com/wow/tank-rankings-tier-list",
        title: "10.2.6 (Season 4) Raid Tank Tier List",
        description: "Weekly rankings curated by the pros at Icy Veins!",
      },
      heal: {
        url: "https://www.icy-veins.com/wow/healer-rankings-tier-list",
        title: "10.2.6 (Season 4) Raid Healer Tier List",
        description: "Weekly rankings curated by the pros at Icy Veins!",
      },
    },
  };

  return (
    <a href={ivLinksAndText[encounterType][role].url} target="_blank">
      <div className="tier-list-cross-link-page-container">
        <div className="cross-link-container">
          <div className="promo-content">
            <div className="left-side-promo-content">
              <IVLogo className="icy-veins-logo" />
              <div className="title-and-subtext">
                <div className="title">{ivLinksAndText[encounterType][role].title}</div>
                <div className="subtext">{ivLinksAndText[encounterType][role].description}</div>
              </div>
            </div>
            <div className="view-rankings-button">
              View Rankings <ExternalLinkIcon className="external-link-icon" />
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default TierListCrossLink;
